import React from 'react'
import { css } from '@emotion/core'
import { Paragraph, Image } from '@fs/zion-ui'
import { string, number, bool, oneOfType } from 'prop-types'
import colorsSet from '../../pages/Activity/colors'
import { ColorThemeType } from '../../sharedPropTypes/activityProps'
import { CompletedCountIndicator } from './CompletedCountIndicator'

export default function ActivityCard({
  constrainedImage = true,
  borderColor,
  title,
  imgUrl,
  colorTheme,
  count,
  activityGroupId,
  id,
}) {
  const color = colorsSet[colorTheme]
  const cardCss = css`
    height: 160px;
    width: 160px;
    border-radius: 10px;
    background-color: ${color?.card?.primary ?? borderColor};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    justify-content: center;
    position: relative;
  `
  const imageProps = constrainedImage ? { maxHeight: '140px', maxWidth: '140px' } : {}

  return (
    <>
      <div css={cardCss} data-testid="activity-card">
        {count > 0 && <CompletedCountIndicator count={count} activityGroupId={activityGroupId} />}
        {imgUrl && <Image alt="" src={imgUrl} {...imageProps} />}
      </div>
      <Paragraph id={`card-label-${activityGroupId ?? id}`} size="xs">
        {title}
      </Paragraph>
    </>
  )
}

ActivityCard.propTypes = {
  constrainedImage: bool,
  borderColor: string,
  title: string,
  imgUrl: string,
  colorTheme: ColorThemeType,
  count: oneOfType([string, number]),
  activityGroupId: oneOfType([string, number]),
  id: oneOfType([string, number]),
}
